<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{caseData.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <v-layout column>
          <v-flex>

              <v-layout row class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <v-avatar
                      :tile="false"
                      :size="72"
                      color="grey lighten-4"
                      class="ma-3 float-left"
                  >
                    <img :src="caseData.created_user.photo.url_resized" alt="avatar">
                  </v-avatar>
                  <div>
                    <p class="title mt-4">{{caseData.created_user.surname + ' ' + caseData.created_user.first_name + ' ' + caseData.created_user.patronymic}}</p>
                    <p class="body-2 mt-3">{{caseData.created_user.user_group.title}}</p>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <div>
                    <span class="title">Дата создания: </span>
                    <span class="title font-weight-thin">{{ $moment(caseData.created_datetime).format('D MMM YYYY, HH:mm') }}</span>
                  </div>
                  <div class="mt-1">
                    <span class="title">% от продаж: </span>
                    <span class="title font-weight-thin">{{caseData.bonus_percent}}</span>
                  </div>
                  <div class="mt-1">
                    <span class="title">Максимальный бонус: </span>
                    <span class="title font-weight-thin">{{caseData.bonus_max_sum}}</span>
                  </div>
                </v-flex>
              </v-layout>

              <p class="title">Каналы продаж</p>
              <v-layout
                  row
                  v-if="channelList.length > 0"
                  class="elevation-1 white mb-4 px-3 pt-3"
              >
                <v-flex xs12 lg6 md6>
                  <div
                      v-for="(channel, index) in channelList"
                      :key="channel.id"
                  >
                    <v-checkbox
                        disabled
                        :label="channel.title"
                        v-model="channelList[index].checked"
                        class="ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>

              <!--<p class="title">Торговые точки</p>-->
              <!--<v-layout row v-if="pointListTreeData !== null && pointListTreeData.length > 0" class="elevation-1 white mb-4 pa-3">-->
                <!--<v-flex xs12 lg6 md6>-->
                  <!--<tree-->
                      <!--:options="{-->
                        <!--checkbox: true-->
                      <!--}"-->
                      <!--:data="pointListTreeData"-->
                      <!--class="tree&#45;&#45;small tree-single-page"-->
                  <!--/>-->
                <!--</v-flex>-->
              <!--</v-layout>-->

              <v-layout row v-if="productGroupList !== null && productGroupList.length > 0">
                <v-flex xs12 lg6 md6>
                  <p class="title">Группы товаров</p>
                  <div
                      class="my-3 pa-2 elevation-1 white"
                      v-for="(productGroup, index) in productGroupList"
                      :key="index"
                  >
                    <v-layout>
                      <v-flex xs4 lg4 md4 class="ml-3">
                        <div><span class="subheading font-weight-black">{{productGroup.title}}</span></div>
                      </v-flex>
                      <v-flex xs4 lg4 md4 class="ml-3">
                        <div><span class="subheading font-weight-black">% точек: </span><span>{{productGroup.pointMinPercent}}</span></div>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="productGroup.skuList.length > 0">
                      <v-flex xs12 lg12 md12>
                        <div class="text-lg-left subheading font-weight-black pl-3">Список SKU:</div>
                        <div class="text-lg-left subheading pl-3 py-0" v-for="(product, index) in productGroup.skuList" :key="index">{{product}}</div>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>

              <p class="text-xs-left title" v-if="caseStatistics !== null" id="statistics">Статистика</p>
              <v-layout row class="elevation-1 white mb-4 pa-3" v-if="caseStatistics !== null">
                <v-flex xs12>
                  <template>
                    <v-layout row v-if="$store.getters.user.sale_group === null">
                      <v-flex xs4 lg4 md4>
                        <v-text-field
                            v-model="statisticsSearch"
                            append-icon="search"
                            label="Поиск"
                            hide-details
                            class="mr-3"
                            @input="onSearch()"
                            outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 lg4 md4>
                        <v-select
                            :items="branchTitleList"
                            label="Филиал"
                            v-model="branch"
                            class="mr-3"
                            @input="onBranchSelect()"
                            hide-details
                            outline
                            no-data-text="Нет данных"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4 lg4 md4>
                        <v-select
                            :items="saleGroupTitleList"
                            label="Супервайзер"
                            v-model="saleGroup"
                            @input="onSaleGroupSelect()"
                            hide-details
                            outline
                            no-data-text="Нет данных"
                            v-if="branch !== 'Все филиалы' && branch !== null"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <v-data-table
                        :headers="statisticsHeaders"
                        :items="statisticsData"
                        class="statistics-table"
                        :rows-per-page-items="[20]"
                        no-data-text="Нет данных"
                        no-results-text="Нет данных"
                        :loading="isStatisticsLoading"
                        :headers-length="statisticsHeaders.length + productGroupList.length + 1"
                        hide-actions
                    >
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th></th>
                          <th v-for="head in props.headers">
                            {{ head.text }}
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>Агенты</th>
                          <th v-for="head in productGroupList">
                            Мин % точек / Факт % точек
                            <br>
                            бонус
                          </th>
                          <th>Итого</th>
                        </tr>
                      </template>
                      <tr slot="items" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td v-for="productGroup in props.item.productGroups" :class="productGroup.completedClass + ' cell-text-center'">
                          {{ productGroup.pointMinPercent }} % / {{ productGroup.point_fact_percent }} %
                          <br>
                          {{ productGroup.bonus_sum }} ₽
                        </td>
                        <td :class="props.item.completedClass + ' cell-text-center'">{{ props.item.bonus_sum }} ₽</td>
                      </tr>
                    </v-data-table>
                    <div class="text-xs-center pt-2">
                      <v-pagination v-model="statisticsPage" :length="statisticsPages" :total-visible="7" @input="statisticsChangePage()"></v-pagination>
                    </div>
                  </template>
                </v-flex>
              </v-layout>

              <v-layout row class="pa-0 mt-3 mb-3">
                <v-flex xs12 lg12 md12>
                  <div class="float-left inline-block">
                    <p class="title">Дата начала</p>
                    <v-date-picker
                        class="mr-3 ml-0 mt-0 mb-3"
                        locale="ru"
                        readonly
                        :value="$moment(caseData.start_date).format('YYYY-MM-DD')"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </div>
                  <div class="inline-block">
                    <p class="title">Дата окончания</p>
                    <v-date-picker
                        class="mr-3 ml-0"
                        locale="ru"
                        readonly
                        :value="$moment(caseData.end_date).format('YYYY-MM-DD')"
                        :first-day-of-week="1"
                    ></v-date-picker>
                  </div>
                </v-flex>
              </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editCase(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить кейс?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteCaseConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Кейсы', link: '/cases/active'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pageDataReady: {
          isReady: false,
          distributionChannelList: false,
          statistics: false,
          branchList: false
        },
        channelIdList: [],
        channelList: [],
        pointListTreeData: [],
        pointFolderIdList: [],
        pointIdList: [],
        productGroupList: [],
        deleteDialog: false,
        statisticsData: [],
        statisticsSearch: '',
        statisticsHeaders: [],
        statisticsPage: 1,
        statisticsLimit: 20,
        isStatisticsLoading: false,
        branch: null,
        branchId: null,
        saleGroup: null,
        saleGroupId: null
      }
    },
    beforeCreate () {
      this.branch = null
      this.branchId = null
      this.saleGroup = null
      this.saleGroupId = null

      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getCaseSingle', {id: this.$route.params.id})
    },
    computed: {
      caseData () {
        return this.$store.getters.caseSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      caseStatistics () {
        return this.$store.getters.caseStatistics
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      saleGroupTitleList () {
        return this.$store.getters.saleGroupTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      saleGroupList () {
        return this.$store.getters.saleGroupList
      },
      statisticsPages () {
        return Math.ceil(this.$store.getters.caseStatisticsTotalCount / this.statisticsLimit)
      }
    },
    methods: {
      editCase (id) {
        this.$router.push('/cases/edit/' + id)
      },
      deleteCaseConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteCase', {id: this.id})
        this.$router.push('/cases/active/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }
        if (!this.pageDataReady.statistics) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== undefined && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getSaleGroupList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
        this.getStatisticsData()
      },
      onSaleGroupSelect () {
        if (this.saleGroup !== null && this.saleGroup !== undefined && this.saleGroup !== 'Все супервайзеры') {
          for (let i = 0; i < this.saleGroupList.length; i++) {
            if (this.saleGroupList[i].title === this.saleGroup) {
              this.saleGroupId = this.saleGroupList[i].id
              break
            }
          }
        } else {
          this.saleGroupId = null
        }
        this.getStatisticsData()
      },
      onSearch () {
        this.statisticsPage = 1
        this.getStatisticsData()
      },
      pointTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeData(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      },
      getStatisticsData () {
        this.isStatisticsLoading = true
        this.$store.dispatch('getCaseStatistics', {
          id: this.id,
          q: this.statisticsSearch,
          branchId: this.branchId,
          saleGroupId: this.saleGroupId,
          limit: this.statisticsLimit,
          offset: (this.statisticsPage - 1) * this.statisticsLimit
        })
      },
      statisticsChangePage () {
        document.getElementById('statistics').scrollIntoView()
        scrollBy(0, -80)

        this.getStatisticsData()
      }
    },
    watch: {
      caseData (n, o) {
        if (typeof this.caseData.distribution_channel_list !== 'undefined') {
          this.channelIdList = []
          for (let i = 0; i < this.caseData.distribution_channel_list.length; i++) {
            this.channelIdList.push(this.caseData.distribution_channel_list[i].id)
          }
        }

        if (typeof this.caseData.point_folder_list !== 'undefined') {
          this.pointFolderIdList = []
          for (let i = 0; i < this.caseData.point_folder_list.length; i++) {
            this.pointFolderIdList.push(this.caseData.point_folder_list[i].id)
          }
        }

        if (typeof this.caseData.point_list !== 'undefined') {
          this.pointIdList = []
          for (let i = 0; i < this.caseData.point_list.length; i++) {
            this.pointIdList.push(this.caseData.point_list[i].id)
          }
        }

        if (typeof this.caseData.case_product_group_list !== 'undefined') {
          this.productGroupList = []
          for (let i = 0; i < this.caseData.case_product_group_list.length; i++) {
            this.productGroupList[i] = {
              title: this.caseData.case_product_group_list[i].title,
              pointMinPercent: this.caseData.case_product_group_list[i].point_min_percent,
              skuList: [],
              id: this.caseData.case_product_group_list[i].id
            }

            for (let k = 0; k < this.caseData.case_product_group_list[i].product_sku_list.length; k++) {
              this.productGroupList[i].skuList[k] = this.caseData.case_product_group_list[i].product_sku_list[k].title
            }
          }
        }

        for (let i = 0; i < this.productGroupList.length; i++) {
          this.statisticsHeaders.push({ text: this.productGroupList[i].title, sortable: false, value: false })
        }

        if (typeof this.caseData.point_folder_tree !== 'undefined') {
          this.pointListTreeData = this.pointTreeData(this.caseData.point_folder_tree)
        }

        if (typeof this.caseData.branch_list !== 'undefined') {
          this.$store.commit('setBranchList', this.caseData.branch_list)
        }

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Кейсы', link: '/cases/active'}
        ]
        this.breadcrumbs.push({name: this.caseData.title})

        this.$store.commit('setPageTitle', this.caseData.title)

        this.$store.dispatch('getDistributionChannelList')
          .then(() => {
            this.pageDataReady.distributionChannelList = true
            this.pageDataStatus()
          })
        // this.$store.dispatch('getPointList')

        this.id = this.caseData.id
        if (this.caseData.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        this.actions.canUpdate = this.caseData.can_update
        this.actions.canRemove = this.caseData.can_remove

        this.getStatisticsData()
      },
      distributionChannelList (n, o) {
        this.channelList = []
        for (let i = 0; i < this.distributionChannelList.length; i++) {
          this.channelList[i] = this.distributionChannelList[i]
        }

        if (this.channelIdList.length > 0) {
          for (let i = 0; i < this.channelList.length; i++) {
            let position = this.channelIdList.indexOf(this.channelList[i].id)
            if (~position) {
              this.channelList[i].checked = true
            } else {
              this.channelList[i].checked = false
            }
          }
        }
      },
      caseStatistics (val) {
        this.pageDataReady.statistics = true
        this.pageDataStatus()

        this.statisticsData = []
        for (let i = 0; i < this.caseStatistics.length; i++) {
          this.statisticsData[i] = {}
          this.statisticsData[i].name = ''
          this.statisticsData[i].name += this.caseStatistics[i].user.surname !== null ? this.caseStatistics[i].user.surname + ' ' : ''
          this.statisticsData[i].name += this.caseStatistics[i].user.first_name !== null ? this.caseStatistics[i].user.first_name + ' ' : ''
          this.statisticsData[i].name += this.caseStatistics[i].user.patronymic !== null ? this.caseStatistics[i].user.patronymic : ''
          this.statisticsData[i].is_completed = this.caseStatistics[i].is_completed
          this.statisticsData[i].completedClass = this.caseStatistics[i].is_completed === 1 ? 'green-cell' : 'red-cell'
          this.statisticsData[i].bonus_sum = this.caseStatistics[i].bonus_sum
          this.statisticsData[i].productGroups = []
          for (let k = 0; k < this.productGroupList.length; k++) {
            for (let j = 0; j < this.caseStatistics[i].case_product_group_statistics_list.length; j++) {
              if (this.productGroupList[k].id === this.caseStatistics[i].case_product_group_statistics_list[j].product_group_id) {
                this.statisticsData[i].productGroups[k] = this.caseStatistics[i].case_product_group_statistics_list[j]
                this.statisticsData[i].productGroups[k].completedClass = this.caseStatistics[i].case_product_group_statistics_list[j].is_completed === 1 ? 'green-cell' : 'red-cell'
                this.statisticsData[i].productGroups[k].pointMinPercent = this.productGroupList[k].pointMinPercent
              }
            }
          }
        }

        this.isStatisticsLoading = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Cases/CaseSingle.vue